import React from 'react';
import styled from '@emotion/styled';
import headerLogo from '../../../assets/images/header-logo2.svg';
import { breakpoints } from '../../../styles/constants'

const LogoStyle = styled.div` 
  width: 300px;
  height: 64px;
  background: url('${headerLogo}') no-repeat center; 
  ${breakpoints.SCREEN_XS} {
    width: 250px;
    height: 53.5px;    
    background-size: 100%;
    margin-bottom: -7px;
  }
`

export function Logo() {
  return <LogoStyle />
}


// WEBPACK FOOTER //
// ./src/modules/login/components/Logo.jsx